import React, { Fragment, useContext, useState } from 'react'

import withView from 'core/components/withView'
import useFetch from 'core/hooks/use-fetch'
import { GlobalContext } from 'core/contexts/global-context'
import { getPostBackgrounds } from 'core/helpers/wp-data-helpers'

import Window from 'core/components/Window'

let key = 'init'
const windows = {}
const Contact = props => {
  const global = useContext(GlobalContext)
  const [open, setOpen] = useState(windows)

  const { loading, error, data } = useFetch('/page/contact', {
    onSuccess: data => global.setBackground(getPostBackgrounds(data))
  })

  const close = e => {
    const field = e.target.dataset.field
    setOpen({ ...open, [field]: false })
  }

  if (loading) return <p>Loading...</p>
  if (error) return <p>An error happened: {data.message}</p>

  if (data.fields) {
    for (const field in data.fields) {
      Object.assign(windows, { [field]: true })
    }

    windows.map = true
    windows.featured_image = true
  }

  Object.keys(open).forEach(field => {
    if (props.location && props.location.key && props.location.key !== key && !open[field]) {
      Object.assign(open, windows)
    }
  })
  if (props.location.key) key = props.location.key

  return global.mobile ? (
    <div className={props.className}>
      <Window
        open
        loading={loading}
        mobile
        fullscreen
        titlebar={{ title: props.title, datafield: 'address' }}
        bounds={null}
      >
        <ul className="contact-list">
          {data.fields.email && (
            <li className="contact-list-item">
              <h1 className="contact-header type-heading mod-xxl-head">Email</h1>
              <p className="contact-field type-body mod-lg-body">{data.fields.email}</p>
            </li>
          )}
          {data.fields.phone && (
            <li className="contact-list-item">
              <h1 className="contact-header type-heading mod-xxl-head">Phone</h1>
              <p className="contact-field type-body mod-lg-body">{data.fields.phone}</p>
            </li>
          )}
          {data.fields.address && (
            <li className="contact-list-item">
              <h1 className="contact-header type-heading mod-xxl-head">Address</h1>
              <p className="contact-field type-body mod-lg-body" style={{ whiteSpace: 'pre-line' }}>
                {data.fields.address}
              </p>
            </li>
          )}

          <li className="contact-list-item">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2885.9479472773082!2d-79.43413498442472!3d43.67005237912074!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b3506b14aea41%3A0x88514d41f12187f6!2sPartisans!5e0!3m2!1sen!2sca!4v1583783542639!5m2!1sen!2sca"
              height="400"
              width="100%"
              frameBorder="0"
              style={{ border: 0, display: 'block' }}
              allowFullScreen=""
            ></iframe>
          </li>
        </ul>
      </Window>
    </div>
  ) : (
    <div className={props.className}>
      {data.fields.phone && (
        <Window
          open={open.phone}
          loading={loading}
          width="auto"
          height="auto"
          x="10%"
          y="5%"
          titlebar={{ title: props.title, close: close, datafield: 'phone' }}
          bounds={null}
        >
          <h1 className="contact-header type-heading mod-xxl-head">Phone</h1>
          <p className="contact-field type-body mod-lg-body">{data.fields.phone}</p>
        </Window>
      )}

      <Window
        open={open.map}
        width="auto"
        height="auto"
        x="30%"
        y="55%"
        titlebar={{ title: props.title, close: close, datafield: 'map' }}
        bounds={null}
      >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2885.9479472773082!2d-79.43413498442472!3d43.67005237912074!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b3506b14aea41%3A0x88514d41f12187f6!2sPartisans!5e0!3m2!1sen!2sca!4v1583783542639!5m2!1sen!2sca"
          width="500"
          height="350"
          frameBorder="0"
          style={{ border: 0, display: 'block' }}
          allowFullScreen=""
        ></iframe>
      </Window>

      {data.featured_image.medium_large && (
        <Window
          open={open.featured_image}
          width="auto"
          height="auto"
          x="5%"
          y="39%"
          titlebar={{ title: props.title, close: close, datafield: 'featured_image' }}
          bounds={null}
        >
          <img
            src={data.featured_image.medium_large[0]}
            style={{ maxWidth: '500px', display: 'block' }}
          />
        </Window>
      )}

      {data.fields.email && (
        <Window
          open={open.email}
          loading={loading}
          width="auto"
          height="auto"
          x="45%"
          y="10%"
          titlebar={{ title: props.title, close: close, datafield: 'email' }}
          bounds={null}
        >
          <h1 className="contact-header type-heading mod-xxl-head">Email</h1>
          <p className="contact-field type-body mod-lg-body">{data.fields.email}</p>
        </Window>
      )}

      {data.fields.address && (
        <Window
          open={open.address}
          loading={loading}
          width="auto"
          height="auto"
          x="45%"
          y="52%"
          titlebar={{ title: props.title, close: close, datafield: 'address' }}
          bounds={null}
          minWidth={650}
        >
          <h1 className="contact-header type-heading mod-xxl-head">Address</h1>
          <p className="contact-field type-body mod-lg-body" style={{ whiteSpace: 'pre-line' }}>
            {data.fields.address}
          </p>
        </Window>
      )}
    </div>
  )
}

export default withView(Contact)
